<app-card-consulta (update)="update.emit($event)" [titulo]="titulo" [idConsulta]='idConsulta'
  [tipoConsulta]="tipoConsulta" [codigoControle]="codigoControle" [status]="status" [msg]="statusMsg">
  <ng-container *ngIf="consulta">
    <div class="card-body p-2 py-1 card-list-striped">
      <ng-container>
        <div class="w-100 d-flex justify-content-between py-1">
          <span class="text-secondary">NOME:</span>
          <span class="text-uppercase">{{ consulta?.nome || msgNull }}</span>
        </div>
        <div class="w-100 d-flex justify-content-between py-1">
          <span class="text-secondary">CNPJ:</span>
          <span class="text-uppercase">{{ consulta?.cnpj || msgNull }}</span>
        </div>
      </ng-container>
    </div>
  </ng-container>

</app-card-consulta>